import * as React from "react";
import { useTranslation } from "react-i18next";
import { IContainerHistoryPoint } from "../interfaces/IContainerHistoryPoint";
import { wrapperStyles } from "../../storeMap/styles/style";

export interface IContainerHistoryPopupHtml {
    containerHistoryPoint?: IContainerHistoryPoint;
}

export const ContainerHistoryPopupHtml: React.FC<IContainerHistoryPopupHtml> = ({ containerHistoryPoint }) => {
    const { t } = useTranslation("admin");
    return (
        <div style={wrapperStyles.popupStyles}>
            <div style={wrapperStyles.popupStyles}>
                {
                    containerHistoryPoint != null && containerHistoryPoint.firstActiveDateStr != containerHistoryPoint.lastActiveDateStr ?
                        <>
                            {t("containers.popup.firstReading")} {containerHistoryPoint != null ? containerHistoryPoint.firstActiveDateStr : ""}< br />
                            {t("containers.popup.lastReading")} {containerHistoryPoint != null ? containerHistoryPoint.lastActiveDateStr : ""}< br />
                        </>
                        :
                        <>
                            {t("containers.popup.reading")} {containerHistoryPoint != null ? containerHistoryPoint.lastActiveDateStr : ""}
                        </>
                }
            </div>
        </div>
    )
}